(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["honeylux-early-access"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('honeylux-launch-window')) {
    customElements.define('honeylux-launch-window', class extends HTMLElement {
      connectedCallback() {
        this.refresh = () => {
          clearTimeout(this.timer);
          const launch = Date.parse(this.dataset.launch);
          const end = Date.parse(this.dataset.end);
          const now = Date.now();
          const phase = this.dataset.phase;
          this.hidden = this.dataset.editor !== 'true' && (phase === 'before' ? now >= launch : phase === 'offer' ? now < launch || now >= end : now < launch);
          const next = [launch, end].find(time => time > now);
          if (next && this.dataset.editor !== 'true') this.timer = setTimeout(this.refresh, Math.min(next - now + 100, 86400000));
        };
        this.refresh();
        window.addEventListener('pageshow', this.refresh);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        window.removeEventListener('pageshow', this.refresh);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["honeylux-subscription-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('honeylux-quick-shop')) {
    customElements.define('honeylux-quick-shop', class extends HTMLElement {
      connectedCallback() {
        if (this.ready || !this.querySelector('[data-hl-form]')) return;
        this.ready = true;
        this.data = JSON.parse(this.querySelector('[data-hl-data]').textContent);
        this.dialog = this.querySelector('dialog');
        this.panel = this.dialog || this.querySelector('[data-hl-inline]');
        this.form = this.querySelector('[data-hl-form]');
        this.abortController = new AbortController();
        const opts = {signal: this.abortController.signal};
        this.querySelectorAll('[data-hl-open]').forEach(button => button.addEventListener('click', () => {
          this.update();
          this.dialog.showModal();
          this.previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          this.scrollLocked = true;
        }, opts));
        this.querySelector('[data-hl-close]')?.addEventListener('click', () => this.dialog.close(), opts);
        this.dialog?.addEventListener('close', () => this.unlockScroll(), opts);
        this.dialog?.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        }, opts);
        this.form.addEventListener('change', event => {
          if (event.target.matches('[data-hl-frequency-choice]')) this.querySelector('[data-hl-frequency]').value = event.target.value;
          this.update();
        }, opts);
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.update();
          if (!this.valid || !this.form.reportValidity()) return;
          this.querySelector('[data-hl-submit]').disabled = true;
          HTMLFormElement.prototype.submit.call(this.form);
        }, opts);
        window.addEventListener('pageshow', () => this.update(), opts);
        this.update();
      }
      unlockScroll() {
        if (!this.scrollLocked) return;
        document.body.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.unlockScroll();
        this.abortController?.abort();
        this.ready = false;
      }
      update() {
        const options = [];
        this.querySelectorAll('[data-hl-option]').forEach(field => {
          options[Number(field.dataset.hlOption)] = field.querySelector('input:checked')?.value;
        });
        const variant = this.data.variants.find(item => item.options.every((value, index) => value === options[index]));
        this.panel.dataset.largeBag = String(this.data.hasLargeImage && options.some(value => /5\s*(lb|pound)/i.test(value || '')));
        const purchaseRadios = [...this.querySelectorAll('[data-hl-purchase]')];
        const subscriptionRadio = purchaseRadios.find(input => input.value === 'subscription');
        const frequency = this.querySelector('[data-hl-frequency]');
        const choices = [...frequency.options];
        choices.forEach(option => { option.disabled = !variant?.plans.some(plan => String(plan.id) === option.value); option.hidden = option.disabled; });
        const hasPlans = choices.some(option => !option.disabled);
        subscriptionRadio.disabled = !hasPlans;
        if (subscriptionRadio.checked && !hasPlans && !this.data.requiresPlan) {
          subscriptionRadio.checked = false;
          purchaseRadios.find(input => input.value === 'once').checked = true;
        }
        const recurring = Boolean(subscriptionRadio.checked);
        if (!choices.some(option => option.selected && !option.disabled)) frequency.value = choices.find(option => !option.disabled)?.value || '';
        frequency.disabled = !recurring;
        this.querySelectorAll('[data-hl-frequency-choice]').forEach(input => {
          const available = choices.some(option => option.value === input.value && !option.disabled);
          input.disabled = !recurring || !available;
          input.closest('label').hidden = !available;
          input.checked = recurring && input.value === frequency.value;
        });
        this.querySelector('[data-hl-frequency-wrap]').hidden = !recurring;
        this.querySelector('[data-hl-pending]').hidden = hasPlans;
        const plan = variant?.plans.find(item => String(item.id) === frequency.value);
        this.querySelector('[data-hl-once-price]')?.replaceChildren(variant?.price || '—');
        this.querySelector('[data-hl-sub-price]').textContent = hasPlans && plan ? plan.price : '';
        const percent = variant?.cents > 0 && plan ? Math.round((variant.cents - plan.cents) / variant.cents * 100) : 0;
        const badge = this.querySelector('[data-hl-discount-badge]');
        badge.textContent = percent > 0 ? this.data.labels.save.replace('[percent]', String(percent)) : '';
        badge.hidden = percent <= 0;
        this.querySelector('[data-hl-benefits]').hidden = !recurring;
        this.valid = Boolean(variant?.available && (recurring ? hasPlans && plan : !this.data.requiresPlan));
        this.querySelector('[data-hl-variant]').value = this.valid ? variant.id : '';
        const planInput = this.querySelector('[data-hl-plan]');
        planInput.disabled = !recurring;
        planInput.value = recurring && plan ? plan.id : '';
        this.querySelector('[data-hl-submit]').disabled = !this.valid;
        this.querySelector('[data-hl-error]').hidden = this.valid;
        const price = this.valid ? (recurring ? plan.price : variant.price) : '—';
        this.querySelector('[data-hl-price]').textContent = price;
        this.querySelector('[data-hl-price-label]').textContent = recurring ? this.data.labels.delivery : '';
        this.querySelector('[data-hl-button-price]').textContent = this.valid ? price : '';
        this.querySelector('[data-hl-button-label]').textContent = recurring && this.dialog ? this.data.labels.subscribe : this.data.labels.add;
        const saving = this.querySelector('[data-hl-saving]');
        saving.textContent = recurring ? plan?.saving || '' : '';
        saving.hidden = !this.valid || !saving.textContent;
        this.querySelector('[data-hl-recurring]').hidden = !recurring;
        this.querySelector('[data-hl-once]').hidden = recurring;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
